export default () => ({
  el: undefined,
  form: undefined,
  input: undefined,
  progress: undefined,
  submitButton: undefined,
  cancelButton: undefined,
  isUploading: false,
  init() {
    mrp.log(`RxInputFile init`);
    this.el = this.$el;
    this.form = this.$refs.form;
    this.input = this.$refs.input;
    this.progress = this.$refs.progress;
    this.submitButton = this.$refs.submitButton;
    this.cancelButton = this.$refs.cancelButton;
    // get update events from htmx on upload progress
    htmx.on(`#${this.form.id}`, "htmx:xhr:progress", (evt) => {
      this.isUploading = true;
      this.submitButton.setAttribute("disabled", "");
      this.input.setAttribute("disabled", "");
      // avoid divide by zero
      if (evt.detail.total === 0) {
        // upload clicked, so move focus back to input
        this.reset(false);
        return;
      }
      // calculate status
      let status = (evt.detail.loaded / evt.detail.total) * 100;
      mrp.log(`RxInputFile progress = ${status}`);
      this.progress.setAttribute("value", status);
      if (status === 100) {
        // reset form on 100%
        this.reset(false);
      }
    });
  },
  change() {
    mrp.log(`RxInputFile change`);
    // enable/disable upload/cancel based on files selected
    if (this.input?.files?.length > 0) {
      this.submitButton.removeAttribute("disabled");
      this.cancelButton.removeAttribute("disabled");
      return;
    }
    this.submitButton.setAttribute("disabled", "");
    this.cancelButton.setAttribute("disabled", "");
  },
  cancel() {
    mrp.log(`RxInputFile cancel`);
    if (this.isUploading) {
      this.input.removeAttribute("disabled");
      htmx.trigger(`#${this.form.id}`, "htmx:abort", {});
    }
    this.reset(true);
  },
  reset(isCancel) {
    mrp.log(`RxInputFile reset`);
    // reset state
    this.isUploading = false;
    this.cancelButton.setAttribute("disabled", "");
    if (!isCancel && !this.input.hasAttribute("multiple")) {
      return;
    }
    this.progress.setAttribute("value", 0);
    this.submitButton.setAttribute("disabled", "");
    this.input.removeAttribute("disabled");
    this.input.focus();
    this.form.reset();
  },
});
